/* NVRSD — sticky add-to-cart bar. Mirrors and drives the main product form. */
if (!customElements.get('nvrsd-sticky-atc')) {
  customElements.define(
    'nvrsd-sticky-atc',
    class NvrsdStickyAtc extends HTMLElement {
      connectedCallback() {
        this.form = document.querySelector('product-form form[id^="product-form-"]');
        this.mainButton = this.form && this.form.querySelector('[type="submit"]');
        if (!this.form || !this.mainButton) return;

        this.button = this.querySelector('[data-sticky-button]');
        this.label = this.querySelector('[data-sticky-label]');
        this.price = this.querySelector('[data-sticky-price]');
        this.hidden = false;

        this.button.addEventListener('click', () => {
          if (this.mainButton.disabled) return;
          this.form.requestSubmit ? this.form.requestSubmit(this.mainButton) : this.mainButton.click();
        });

        // Show only once the main buy button has scrolled above the viewport
        this.observer = new IntersectionObserver(([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', scrolledPast);
          this.setAttribute('aria-hidden', String(!scrolledPast));
          this.button.tabIndex = scrolledPast ? 0 : -1;
        });
        this.observer.observe(this.mainButton);

        // Keep label, state and price in sync with the main form (variant changes, sold out, loading)
        this.sync = this.sync.bind(this);
        this.mutations = new MutationObserver(this.sync);
        this.mutations.observe(this.mainButton, { attributes: true, childList: true, subtree: true, characterData: true });
        const mainPrice = document.querySelector('[id^="price-template"]');
        if (mainPrice) this.mutations.observe(mainPrice, { childList: true, subtree: true, characterData: true });
        this.sync();
      }

      disconnectedCallback() {
        this.observer && this.observer.disconnect();
        this.mutations && this.mutations.disconnect();
      }

      sync() {
        const text = this.mainButton.querySelector('span');
        if (text && text.textContent.trim()) this.label.textContent = text.textContent.trim();
        this.button.disabled = this.mainButton.disabled;
        this.button.classList.toggle('is-loading', this.mainButton.classList.contains('loading'));
        const current = document.querySelector('[id^="price-template"] .price-item--last, [id^="price-template"] .price__regular .price-item');
        if (current && current.textContent.trim()) this.price.textContent = current.textContent.trim();
      }
    }
  );
}
